import { styled } from "../../theme";

export const Container = styled.div`
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const TextTitleContainer = styled.div``;
